import * as React from "react";
import { useState } from "react";
import { ErrorScreen } from "@stenajs-webui/panels";
import { CustomerExpectedVolumePane } from "@/features/expected-volume/components/CustomerExpectedVolumePane";
import { useParams } from "react-router";
import { Helmet } from "react-helmet";
import { useNegotiationYears } from "@/contexts/NegotiationYearGate";
import { useExpectedVolume } from "@/features/expected-volume/hooks/UseExpectedVolume";

export interface CustomerExpectedVolumeScreenParams {
  customerId: string;
}

interface Props {}

export const CustomerExpectedVolumeScreen: React.FC<Props> = () => {
  const { customerId } = useParams() as { customerId: string };
  const { defaultYear } = useNegotiationYears();
  const [year, setYear] = useState(defaultYear);

  if (!customerId) {
    return <ErrorScreen text={"No customerId provided"} />;
  }

  const {
    expectedVolumeByRoute,
    customer,
    routePairsWithStatusOwn,
    error,
    loading,
  } = useExpectedVolume(customerId, year);

  return (
    <>
      <Helmet title="Expected volume - Customer - FPP" />
      <CustomerExpectedVolumePane
        customerId={customerId}
        year={year}
        setYear={setYear}
        expectedVolumeByRoute={expectedVolumeByRoute}
        customer={customer}
        routePairsWithStatusOwn={routePairsWithStatusOwn}
        error={error}
        loading={loading}
      />
    </>
  );
};
